<!-- 修改兑换截止时间 -->
<template>
  <div class="cus-modal">
    <OmsForm :form-config="formConfig"/> 
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      formConfig: {
        formData: [
          {
            style: 'date',
            type: 'date',
            value: 'deadline',
            label: t('兑换截止日期'),
            width: '24',
            format: 'yyyy-MM-dd',
            options: {
              disabledDate (date) {
                return date && date.valueOf() < Date.now() - 86400000;
              }
            }
          },
        ],
        formValue: {
          deadline: '',
        },
        ruleValidate: {
          deadline: [{ required: true, message: ' ', trigger: 'blur' }]
        }
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.determine();
            }, // 按钮点击事件
          }
        ],
      },
    }
  },
  props: {
    componentData: {
      type: Object,
    }
  },
  methods: {
    async determine() {
      console.log(this)
      const { deadline } = this.formConfig.formValue
      if (!deadline) return $fcWarn({ content: t('兑换截止日期不能为空！') })
      const params = {
        ids: this.componentData.ids,
        deadline: deadline ? $utils.Format(new Date(deadline), 'yyyy-MM-dd') : ''
      }
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/giftExchange/deadline/modify', params).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          const tab = this.$parent.$parent.$parent.queryTab('OC_B_ORDER_GIFT_EXCHANGE')
          this.$parent.$parent.$parent.labelClick(tab); // 刷新子表
        }
      })
    },
  }
}
</script>
